import React from 'react';
import { BlankLink } from '@contently/toolkit';
import GA from '../utils/GoogleAnalytics';

const handleClick = () => {
  if (GA.trackingEnabled) {
    GA.client.event({
      category: 'User',
      action: 'CTA clicked',
      label: 'Talent one-sheet'
    });
  }
};

export default () => {
  return (
    <>
      Find out more about our network&nbsp;
      <BlankLink
        onClick={handleClick}
        href="https://contently-2639.docs.contently.com/v/contently-talent-network"
        title="Talent one-sheet"
      >
        here.
      </BlankLink>
    </>
  );
};
